<template>
  <div ref="scroll" class="components__competency-accordion">
    <GenericAccordion v-if="competency" v-model="competency.expanded">
      <template v-slot:header>
        <h2>{{competency.abbreviation}} - {{competency.name}}</h2>
      </template>
      <template v-slot:content>
        <template v-if="competency.descriptions.length > 0">
          <ul>
            <li
              v-for="(description, index) in competency.descriptions"
              v-bind:key="index"
            >{{description}}</li>
          </ul>
        </template>
        <div
          class="sub-competency"
          v-bind:class="{highlight: sub_competency.highlighted}"
          v-for="sub_competency in competency.sub_competencies"
          v-bind:key="sub_competency.id"
        >
          <div class="sub-competency__abbreviation">{{sub_competency.abbreviation}}:</div>
          <div>{{sub_competency.description}}</div>
        </div>
      </template>
    </GenericAccordion>
  </div>
</template>

<style lang="scss" scoped>
@import "~stylesheets/frontend/variables/colors";

.components__competency-accordion {
  .sub-competency {
    display: flex;
    padding: 5px;

    &.highlight {
      background-color: $color-green-hueish;
    }

    .sub-competency__abbreviation {
      margin-right: 10px;
    }
  }
}
</style>

<script lang="ts" setup>
  import { nextTick, ref, watch } from "vue";
  
  import GenericAccordion from "vue/applications/frontend/components/generic-accordion.vue";

  defineProps({
    competency: {
      type: Object,
      default: null,
    } 
  });

  const competency = ref({jump_target: false});
  const scroll = ref<HTMLElement | null>(null);

  watch(() => competency.value.jump_target, (newValue) => {
    if (newValue) {
      nextTick().then(() => {
        const element = scroll.value;
        if(element){
          // This is a hack because directly executing won't work
          setTimeout(() => {
            element.scrollIntoView();
            competency.value.jump_target = false;
          }, 200);
        }
      }); 
    }
  }, { immediate: true });
</script>
